import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
        <i className="ri-compass-3-line text-3xl"></i>
      </span>
      <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950">
        Página no encontrada
      </h1>
      <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        La página que busca no existe o no tiene permisos para acceder a ella.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-10 cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line text-base"></i>
        Volver al inicio
      </Link>
    </div>
  );
}